import { facadeApi } from 'api'
import { TenantIdp } from 'types/tenants/tenant'

interface Params {
  tenantId: string
}

export const fetchTenantIdpsApi = ({ tenantId }: Params) => facadeApi.get<TenantIdp[]>(`/tenants/${tenantId}/idps`)
